/**
 * ClassName utility function
 * Merges class names conditionally (similar to clsx)
 */

type ClassValue =
  | string
  | number
  | boolean
  | undefined
  | null
  | ClassValue[];

/**
 * Merges class names, filtering out falsy values
 * @param classes - Array of class values
 * @returns Merged class name string
 */
export function cn(...classes: ClassValue[]): string {
  return classes
    .flat()
    .filter(Boolean)
    .join(' ')
    .trim();
}

/**
 * Conditionally applies classes based on a condition
 * @param condition - Boolean condition
 * @param truthyClasses - Classes to apply if true
 * @param falsyClasses - Classes to apply if false
 * @returns Class name string
 */
export function conditionalClass(
  condition: boolean,
  truthyClasses: string,
  falsyClasses: string = ''
): string {
  return condition ? truthyClasses : falsyClasses;
}
